"use client";

import { c as _c } from "react/compiler-runtime";
import { AccountCircle } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { getProfileUrlByIdentifier } from "@/components/profile/utils";
import { useAddress } from "@/hooks/wallet";
import { AccountSwitcherItem, AccountSwitcherItemAvatar, AccountSwitcherItemContent, AccountSwitcherItemTitle } from "./AccountSwitcherItem";
export function AccountSwitcherProfileItem(_) {
  const $ = _c(10);
  const address = useAddress();
  const t = useTranslations("AccountSwitcherProfileItem");
  let t0;
  if ($[0] !== address) {
    t0 = getProfileUrlByIdentifier(address);
    $[0] = address;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AccountSwitcherItemAvatar icon={AccountCircle} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <AccountSwitcherItemContent><AccountSwitcherItemTitle>{t2}</AccountSwitcherItemTitle></AccountSwitcherItemContent>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t3) {
    t4 = <AccountSwitcherItem href={t0}>{t1}{t3}</AccountSwitcherItem>;
    $[7] = t0;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}